/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/oferta'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import PublicOferta from '@routes/StaticPages/LegalPages/PublicOferta';

export const Route = createFileRoute('/oferta')({
  component: () => (
    <CacheDataRoute component={PublicOferta} path='/oferta' />
  )
});
